import { render, staticRenderFns } from "./createEditGroup.vue?vue&type=template&id=e60893d4&scoped=true&"
import script from "./createEditGroup.vue?vue&type=script&lang=js&"
export * from "./createEditGroup.vue?vue&type=script&lang=js&"
import style0 from "./createEditGroup.vue?vue&type=style&index=0&id=e60893d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60893d4",
  null
  
)

export default component.exports